module.exports = __webpack_public_path__ + "static/faktum-regular-f843039bc6a6b039b987e33ff2484bf2.woff2";